import { render, staticRenderFns } from "./expenses-edit-modal.vue?vue&type=template&id=3acd0a67&scoped=true&"
import script from "./expenses-edit-modal.vue?vue&type=script&lang=js&"
export * from "./expenses-edit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd0a67",
  null
  
)

export default component.exports